import { apiDaInscricao } from "../../../servicos/axios";

export type CriarAgendamentoPayload = {
  dataInicial: string;
  dataFinal: string;
  pessoa: {
    nome: string;
    cpf: string;
    telefoneCelular?: string;
  };
};

export const criarAgendamento = async (payload: CriarAgendamentoPayload) => {
  const api = apiDaInscricao();
  const { data } = await api.post("/agendamento/Criar", payload);
  return data?.agendamento ?? data;
};
